const phrases = `Please look into this and fix it so it doesn't happen again
I appreciate your prompt attention to this matter
It's important to have it repaired as soon as possible to avoid any further issues
Thank you for your prompt attention to this issue
I am also thinking about making an official complaint about this
Please make necessary actions so that this doesnt happen again
It's important to make sure this doesn't happen to anyone else
Both choices have good and not-so-good things
Each option has its own advantages and disadvantages
It's important to think about what works best for you and your goals
It was a special moment that I will always cherish
I'll keep you posted on how things go!
I was completely surprised, to be honest
It's important to think about it
I think we can find a balance
Some people think this is a good idea, and some don't
It's important to talk about it
I'll let you know how it goes
Thanks for listening!
Sincerely
I hope you're well
Thank you for listening
In light of this situation
Take care`;

export default phrases;